/* AceBeach prototype engine — header/footer, nav, mobile drawer, slideshow, categories, quick-view, cart, request forms */
const ACE = (()=>{
  const PHONE = "(855) 523-2245";
  const ACE_LOGO=(typeof window!=="undefined"&&window.ACE_ASSETS&&window.ACE_ASSETS.logo)||"logo_t.png";
  const NAV = [
    {key:"popular", label:"Popular", href:"/collections/all?sort_by=best-selling"},
    {key:"nintendo", label:"Nintendo", href:"/collections/nintendo"},
    {key:"playstation", label:"PlayStation", href:"/collections/ps4-ps5"},
    {key:"xbox", label:"Xbox", href:"/collections/xbox-consoles-accessories"},
    {key:"toys", label:"Toys", href:"/collections/toys"},
    {key:"health", label:`<span class="hh-stack">Health<i>&amp;</i>Hygiene</span>`, plain:"Health & Hygiene", href:"/collections/health-hygiene"},
  ];
  const PILL = {key:"looking", label:"Looking for Something?", href:"/pages/looking-for-something"};
  const TAGS = {nintendo:"Nintendo",playstation:"PlayStation",xbox:"Xbox",toys:"Collectible",popular:"Best Seller",newarrivals:"New Arrival",health:"Health & Hygiene"};
  const tagFor = k => TAGS[k] || "AceBeach";
  let CATALOG = null;
  let cart = [];
  try{ cart = JSON.parse(localStorage.getItem("ace_cart_items")||"[]") || []; }catch(e){ cart = []; }
  let pendingRemove = null;
  const money = p => "$" + (p||"");
  const TRASH = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>`;

  /* ---------- chrome ---------- */
  function header(active){
    const links = NAV.map(n=>`<a href="${n.href}" class="${n.key===active?'active':''}">${n.label}</a>`).join("");
    const drawerLinks = [...NAV, PILL, {label:"About",href:"/"}, {label:"Contact",href:"/"}]
      .map(n=>`<a href="${n.href}">${n.plain||n.label}</a>`).join("");
    return `
    <div class="announce">Only Brand New Products &nbsp;·&nbsp; Same Business Day Shipping &nbsp;·&nbsp; No Tax (NV &amp; WA Excluded) &nbsp;·&nbsp; Call ${PHONE}</div>
    <header class="site"><div class="wrap topbar">
      <div class="left-group">
        <a class="brand" href="/" aria-label="AceBeach home">
          <img src="${ACE_LOGO}" alt="AceBeach">
          <span class="slogan gold-text">No Gambles<br>Just Guarantees</span>
        </a>
        <button id="searchBtn" title="Search" aria-label="Search"><svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg></button>
      </div>
      <nav class="main">${links}<a class="nav-pill ${active==='looking'?'active':''}" href="${PILL.href}">${PILL.label}</a></nav>
      <div class="icons">
        <button id="cartBtn" title="Cart"><svg viewBox="0 0 24 24"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9" cy="20" r="1"/><circle cx="18" cy="20" r="1"/><path d="M6 6 5 3H2"/></svg><span class="cart-badge" id="cartBadge" style="display:none">0</span></button>
        <button class="hamburger" id="hamBtn" aria-label="Menu"><span></span><span></span><span></span></button>
      </div>
    </div></header>
    <div class="drawer" id="drawer"><div class="drawer-inner">
      <div class="drawer-head">Browse</div>
      ${drawerLinks}
    </div></div>`;
  }

  function footer(){
    return `<footer class="site"><div class="wrap">
      <div class="fgrid">
        <div>
          <img class="flogo" src="${ACE_LOGO}" alt="AceBeach">
          <div class="fslogan gold-text">No Gambles · Just Guarantees</div>
          <p class="small">Hard-to-find gaming &amp; collectibles, every item brand new and authenticated. Family-run since 2007.<br>Toll Free ${PHONE}</p>
        </div>
        <div><h4>Shop</h4><ul>
          <li><a href="/collections/all?sort_by=best-selling">Popular</a></li>
          <li><a href="/collections/nintendo">Nintendo</a></li>
          <li><a href="/collections/ps4-ps5">PlayStation</a></li>
          <li><a href="/collections/toys">Toys &amp; Collectibles</a></li>
        </ul></div>
        <div><h4>Help</h4><ul>
          <li><a href="/">Looking for Something?</a></li>
          <li><a href="/">Contact Us</a></li>
          <li><a href="/">Shipping &amp; Returns</a></li>
        </ul></div>
        <div><h4>Company</h4><ul>
          <li><a href="/">About AceBeach</a></li>
          <li><a href="/">Privacy Policy</a></li>
          <li><a href="/">Terms</a></li>
        </ul></div>
      </div>
      <div class="copy">© 2026 AceBeach. All rights reserved. · No Gambles, Just Guarantees.</div>
    </div></footer>`;
  }

  function trust(){
    return `<div class="trust"><div class="wrap">
      <div class="item"><span class="gold-text">✓</span> <b>Authorize.Net</b> Verified</div>
      <div class="item"><span class="gold-text">✓</span> <b>PayPal</b> &amp; <b>Amazon Pay</b></div>
      <div class="item"><span class="gold-text">✓</span> 100% Brand New, <b>Guaranteed</b></div>
      <div class="item"><span class="gold-text">✓</span> Call Toll Free <b>${PHONE}</b></div>
    </div></div>`;
  }
  function trustMount(){ const t=document.getElementById("trust"); if(t) t.innerHTML=trust(); }

  /* ---------- products ---------- */
  function card(p, cat){
    if(p.sold){
      return `<div class="card sold" data-handle="${p.handle}" data-cat="${cat}">
        <div class="ph"><span class="sold-badge">Sold Out</span><img src="${p.img}" alt="${p.title.replace(/"/g,'')}"></div>
        <div class="body">
          <div class="tag">${tagFor(cat)}</div><h3>${p.title}</h3>
          <div class="price sold-price">Sold Out</div>
          <button class="add notify" data-handle="${p.handle}">Notify Me</button>
        </div></div>`;
    }
    return `<div class="card" data-handle="${p.handle}" data-cat="${cat}">
      <div class="ph"><img src="${p.img}" alt="${p.title.replace(/"/g,'')}"></div>
      <div class="body">
        <div class="tag">${tagFor(cat)}</div><h3>${p.title}</h3>
        <div class="price gold-text">${money(p.price)}</div>
        <button class="add" data-handle="${p.handle}">Add to Cart</button>
      </div></div>`;
  }
  const grid = (items,cat)=>`<div class="grid">${items.map(p=>card(p,cat)).join("")}</div>`;

  function find(handle){ for(const k in CATALOG){ const f=CATALOG[k].find(p=>p.handle===handle); if(f) return {p:f,cat:k}; } return null; }

  function openModal(handle){
    const r=find(handle); if(!r) return; const {p,cat}=r;
    document.getElementById("mImg").src=p.img; document.getElementById("mImg").alt=p.title;
    document.getElementById("mTag").textContent=tagFor(cat);
    document.getElementById("mTitle").textContent=p.title;
    const price=document.getElementById("mPrice"), stock=document.getElementById("mStock"), add=document.getElementById("mAdd");
    add.dataset.handle=p.handle;
    if(p.sold){
      price.textContent=money(p.price); price.classList.add("struck");
      stock.textContent="◆ Sold Out — New Stock Coming Soon"; stock.className="stock sold";
      add.textContent="Notify Me When Available"; add.dataset.sold="1";
    }else{
      price.textContent=money(p.price); price.classList.remove("struck");
      stock.textContent="● In Stock — Ships Same Business Day"; stock.className="stock";
      add.textContent="Add to Cart"; add.dataset.sold="";
    }
    document.getElementById("overlay").classList.add("open");
  }
  const closeModal=()=>document.getElementById("overlay").classList.remove("open");
  function goNotify(handle){ location.href="/pages/looking-for-something"; }

  let LASTCART={items:[],item_count:0,total_price:0};
  function updateBadge(){ const b=document.getElementById("cartBadge"); if(!b) return; const q=LASTCART.item_count||0; if(q>0){ b.style.display="flex"; b.textContent=q; } else { b.style.display="none"; } }
  async function refreshCart(){ try{ LASTCART=await fetch("/cart.js",{headers:{Accept:"application/json"}}).then(r=>r.json()); }catch(e){ LASTCART={items:[],item_count:0,total_price:0}; } updateBadge(); renderCart(); return LASTCART; }
  let cartBusy=false;
  async function cartAdd(handle){
    if(cartBusy) return; cartBusy=true;
    try{
      const pj=await fetch("/products/"+handle+".js",{headers:{Accept:"application/json"}}).then(r=>r.json());
      const v=(pj.variants||[]).find(x=>x.available)||(pj.variants||[])[0];
      if(!v){ toast("Currently unavailable"); return; }
      const res=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({items:[{id:v.id,quantity:1}]})});
      if(!res.ok){ const er=await res.json().catch(function(){return null;}); toast((er&&er.description)||"That's all we have in stock"); return; }
      await refreshCart(); toast("Added to cart");
    }catch(e){ toast("Could not add to cart"); }
    finally{ cartBusy=false; }
  }
  async function cartChange(key,qty){
    if(cartBusy) return; cartBusy=true;
    try{
      const res=await fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:key,quantity:qty})});
      const data=await res.json().catch(function(){return null;});
      if(res.ok && data && Array.isArray(data.items)){
        LASTCART=data;
        const ln=data.items.find(function(x){return x.key===key;});
        if(qty>0 && ln && ln.quantity<qty){ toast("That's all we have in stock"); }
        updateBadge(); renderCart();
      } else {
        toast("That's all we have in stock"); await refreshCart();
      }
    }catch(e){ await refreshCart(); }
    finally{ cartBusy=false; }
  }
  function askRemove(key){ pendingRemove=key; const c=document.getElementById("confirmOverlay"); if(c) c.classList.add("open"); }
  function closeConfirm(){ pendingRemove=null; const c=document.getElementById("confirmOverlay"); if(c) c.classList.remove("open"); }
  function renderCart(){
    const body=document.getElementById("cartBody"); if(!body) return;
    const foot=document.getElementById("cartFoot");
    const items=LASTCART.items||[];
    if(!items.length){ body.innerHTML='<div class="cart-empty">Your cart is empty.</div>'; if(foot) foot.style.display="none"; return; }
    body.innerHTML=items.map(i=>{ const img=i.image||(i.featured_image&&i.featured_image.url)||"";
      return `<div class="ci"><img src="${img}" alt=""><div class="ci-info"><div class="ci-name">${i.product_title}</div><div class="ci-price gold-text">$${(i.final_line_price/100).toFixed(2)}</div>
        <div class="ci-qty"><button data-q="-1" data-k="${i.key}">−</button><span>${i.quantity}</span><button data-q="1" data-k="${i.key}">+</button></div></div><button class="ci-rm" data-rk="${i.key}" title="Remove item" aria-label="Remove item">${TRASH}</button></div>`;
    }).join("");
    if(foot) foot.style.display="block";
    const s=document.getElementById("cartSub"); if(s) s.textContent="$"+((LASTCART.total_price||0)/100).toFixed(2);
  }
  async function openCart(){ await refreshCart(); document.getElementById("cartPanel").classList.add("open"); document.getElementById("cartOverlay").classList.add("open"); }
  function closeCart(){ document.getElementById("cartPanel").classList.remove("open"); document.getElementById("cartOverlay").classList.remove("open"); }
  let toastTimer;
  function toast(msg){ const t=document.getElementById("toast"); t.textContent=msg; t.classList.add("show"); clearTimeout(toastTimer); toastTimer=setTimeout(()=>t.classList.remove("show"),2000); }

  /* ---------- search ---------- */
  let searchTimer;
  async function doSearch(q){
    const box=document.getElementById("searchResults"); if(!box) return;
    if(!q.trim()){ box.innerHTML='<div class="search-hint">Start typing — try amiibo, Ganondorf, PS5, or Wicked.</div>'; return; }
    try{
      const r=await fetch("/search/suggest.json?q="+encodeURIComponent(q)+"&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=last",{headers:{Accept:"application/json"}}).then(r=>r.json());
      var _all=(((r.resources||{}).results||{}).products)||[];
      var _HS=window.ACE_HIDE_SET||(window.ACE_HIDE_SET=(function(){var o={};(window.ACE_HIDE||[]).forEach(function(h){o[h]=1});return o;})());
      const items=_all.filter(function(p){var h=((p.url||"").split("/products/")[1]||"").split("?")[0].split("#")[0];return !_HS[h];});
      if(!items.length){ box.innerHTML='<div class="search-none">No results for "'+q.replace(/</g,"")+'". <a href="/pages/contact" class="gold-text">Ask us to find it</a>.</div>'; return; }
      box.innerHTML='<div class="search-meta">'+items.length+' result'+(items.length>1?'s':'')+'</div><div class="grid">'+items.map(function(p){ var img=(p.featured_image&&(p.featured_image.url||p.featured_image))||p.image||""; var pr=(typeof p.price==="number")?("$"+(p.price/100).toFixed(2)):(p.price?(String(p.price).trim().charAt(0)==="$"?p.price:"$"+p.price):""); return '<a class="card" href="'+p.url+'"><div class="ph"><img src="'+img+'" alt=""></div><div class="body"><div class="tag">In Stock</div><h3>'+p.title+'</h3><div class="price gold-text">'+pr+'</div></div></a>'; }).join('')+'</div>';
    }catch(e){ box.innerHTML='<div class="search-none">Search is unavailable right now.</div>'; }
  }
  function renderSearch(q){ clearTimeout(searchTimer); searchTimer=setTimeout(function(){ doSearch(q); },180); }
  async function openSearch(){ const o=document.getElementById("searchOverlay"); o.classList.add("open"); const i=document.getElementById("searchInput"); i.value=""; doSearch(""); setTimeout(()=>i.focus(),50); }
  function closeSearch(){ const o=document.getElementById("searchOverlay"); if(o) o.classList.remove("open"); }

  function chrome(active){
    document.getElementById("header").innerHTML = header(active);
    document.getElementById("footer").innerHTML = footer();
    updateBadge();
    // hamburger
    document.getElementById("hamBtn").onclick=()=>{ document.getElementById("drawer").classList.toggle("open"); document.getElementById("hamBtn").classList.toggle("x"); };
    // modal + toast + cart drawer (once)
    if(!document.getElementById("overlay")){
      var aceUI=document.createElement("div"); aceUI.id="aceUI"; aceUI.className="ace-scope"; document.body.appendChild(aceUI);
      const o=document.createElement("div"); o.id="overlay"; o.className="overlay";
      o.innerHTML=`<div class="modal">
        <button class="close" id="mClose">×</button>
        <div class="mimg"><img id="mImg" src="" alt=""></div>
        <div class="minfo">
          <div class="mtag" id="mTag"></div><h2 id="mTitle"></h2>
          <div class="mprice gold-text" id="mPrice"></div>
          <div class="stock" id="mStock">● In Stock — Ships Same Business Day</div>
          <p class="mdesc">100% brand new and authenticated. Backed by the AceBeach guarantee — no gambles, just guarantees. Questions? Call ${PHONE}.</p>
          <button class="gold-btn" id="mAdd">Add to Cart</button>
        </div></div>`;
      aceUI.appendChild(o);
      const t=document.createElement("div"); t.id="toast"; t.className="toast"; aceUI.appendChild(t);
      const co=document.createElement("div"); co.id="cartOverlay"; co.className="cart-overlay"; aceUI.appendChild(co);
      const cp=document.createElement("aside"); cp.id="cartPanel"; cp.className="cart-panel";
      cp.innerHTML=`<div class="cart-head"><span>Your Cart</span><button id="cartClose">×</button></div>
        <div id="cartBody" class="cart-body"></div>
        <div id="cartFoot" class="cart-foot">
          <div class="cart-sub"><span>Subtotal</span><span id="cartSub" class="gold-text">$0.00</span></div>
          <button class="gold-btn" id="cartCheckout" style="width:100%">Checkout</button>
          <p class="cart-note">Secure checkout — Authorize.Net · PayPal · Amazon Pay</p>
        </div>`;
      aceUI.appendChild(cp);
      o.addEventListener("click",e=>{ if(e.target===o) closeModal(); });
      document.getElementById("mClose").onclick=closeModal;
      document.getElementById("mAdd").onclick=function(){ if(this.dataset.sold){ goNotify(this.dataset.handle); } else { cartAdd(this.dataset.handle); } };
      document.getElementById("cartClose").onclick=closeCart;
      co.addEventListener("click",closeCart);
      document.getElementById("cartCheckout").onclick=()=>{ window.location.href="/checkout"; };
      const cf=document.createElement("div"); cf.id="confirmOverlay"; cf.className="confirm-overlay";
      cf.innerHTML=`<div class="confirm-box">
        <p>Are you sure you would like to remove this item from your cart?</p>
        <div class="confirm-btns"><button class="cf-no" id="confirmNo">No</button><button class="cf-yes gold-btn" id="confirmYes">Yes</button></div>
      </div>`;
      aceUI.appendChild(cf);
      cf.addEventListener("click",e=>{ if(e.target===cf) closeConfirm(); });
      document.getElementById("confirmNo").onclick=closeConfirm;
      document.getElementById("confirmYes").onclick=()=>{ if(pendingRemove) cartChange(pendingRemove,0); closeConfirm(); };
      const so=document.createElement("div"); so.id="searchOverlay"; so.className="search-overlay";
      so.innerHTML=`<div class="search-panel"><div class="search-bar">
        <svg viewBox="0 0 24 24" fill="none" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg>
        <input id="searchInput" type="text" placeholder="Search products… (e.g. amiibo, Ganondorf, PS5)" autocomplete="off">
        <button id="searchClose" aria-label="Close">×</button>
      </div><div id="searchResults" class="search-results"></div></div>`;
      aceUI.appendChild(so);
      so.addEventListener("click",e=>{ if(e.target===so) closeSearch(); });
      document.getElementById("searchClose").onclick=closeSearch;
      document.getElementById("searchInput").addEventListener("input",e=>renderSearch(e.target.value));
      document.addEventListener("keydown",e=>{ if(e.key==="Escape"){ closeSearch(); closeModal(); closeCart(); closeConfirm(); } });
      document.addEventListener("click",e=>{
        const qb=e.target.closest("[data-q]"); if(qb){ const it=(LASTCART.items||[]).find(x=>x.key===qb.dataset.k); if(it) cartChange(qb.dataset.k, it.quantity+parseInt(qb.dataset.q,10)); return; }
        const rm=e.target.closest("[data-rk]"); if(rm){ askRemove(rm.dataset.rk); return; }
        const add=e.target.closest(".add");
        if(add){ e.preventDefault(); e.stopPropagation(); if(add.disabled){ return; } if(add.classList.contains("notify")){ goNotify(add.dataset.handle); } else { cartAdd(add.dataset.handle); } return; }
        const sl=e.target.closest(".slide"); if(sl){ openModal(sl.dataset.handle); return; }
        const c=e.target.closest(".card"); if(c){ if(c.tagName!=="A") openModal(c.dataset.handle); return; }
        if(e.target.closest("#searchBtn")){ openSearch(); return; }
        if(e.target.closest("#cartBtn")) openCart();
      });
    }
  }
  function mount(active){ chrome(active||""); }

  async function load(){ if(!CATALOG){ CATALOG=window.ACE_CATALOG_DATA||(await fetch(((window.ACE_ASSETS&&window.ACE_ASSETS.catalog)||"catalog.json")).then(r=>r.json())); } return CATALOG; }

  /* ---------- slideshow ---------- */
  function slideshow(items){
    const slides=items.map((p,i)=>`
      <button class="slide ${i===0?'on':''}" data-handle="${p.handle}">
        <img src="${p.img}" alt="${p.title.replace(/"/g,'')}">
        <div class="slide-cap"><span class="sc-tag">${tagFor("popular")}</span><span class="sc-name">${p.title}</span><span class="sc-price">${money(p.price)}</span></div>
      </button>`).join("");
    const dots=items.map((_,i)=>`<span class="dot ${i===0?'on':''}" data-i="${i}"></span>`).join("");
    return `<div class="slideshow" id="heroShow">
      <div class="slides">${slides}</div>
      <button class="sl-arrow left" id="slPrev" aria-label="Previous">‹</button>
      <button class="sl-arrow right" id="slNext" aria-label="Next">›</button>
      <div class="dots">${dots}</div>
    </div>`;
  }
  function initSlideshow(){
    const slides=[...document.querySelectorAll("#heroShow .slide")];
    const dots=[...document.querySelectorAll("#heroShow .dot")];
    if(!slides.length) return;
    let idx=0, timer;
    const show=i=>{ idx=(i+slides.length)%slides.length; slides.forEach((s,j)=>s.classList.toggle("on",j===idx)); dots.forEach((d,j)=>d.classList.toggle("on",j===idx)); };
    const start=()=>timer=setInterval(()=>show(idx+1),3800);
    const reset=()=>{ clearInterval(timer); start(); };
    dots.forEach(d=>d.addEventListener("click",ev=>{ ev.stopPropagation(); show(+d.dataset.i); reset(); }));
    document.getElementById("slPrev").addEventListener("click",ev=>{ ev.stopPropagation(); show(idx-1); reset(); });
    document.getElementById("slNext").addEventListener("click",ev=>{ ev.stopPropagation(); show(idx+1); reset(); });
    start();
  }

  /* ---------- pages ---------- */
  async function home(){
    chrome("home"); await load();
    var _HS=window.ACE_HIDE_SET||(window.ACE_HIDE_SET=(function(){var o={};(window.ACE_HIDE||[]).forEach(function(h){o[h]=1});return o;})());
    var _seen={}, _pool=[];
    Object.keys(CATALOG).forEach(function(k){ (CATALOG[k]||[]).forEach(function(p){ if(!_seen[p.handle]&&!_HS[p.handle]){ _seen[p.handle]=1; _pool.push(p); } }); });
    const shuffle=a=>{a=a.slice();for(let i=a.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[a[i],a[j]]=[a[j],a[i]];}return a;};
    const featured=shuffle(_pool.slice(4)).slice(0,8).map(p=>({p,cat:"popular"}));
    const featGrid=`<div class="grid">${featured.map(f=>card(f.p,f.cat)).join("")}</div>`;
    const slideItems=_pool.slice(0,6);
    document.getElementById("main").innerHTML=`
      <div class="hero"><div class="wrap">
        <div>
          <div class="eyebrow gold-text">Brand New · Authenticated · Guaranteed</div>
          <h1>SPECIALIZING IN<br><span class="gold-text">HARD TO FIND PRODUCTS</span></h1>
          <p>From consoles and collectibles to everyday essentials — if it's tough to track down, we've got it. Every item brand new, authenticated, and shipped the same business day. No gambles. Just guarantees.</p>
          <a class="gold-btn" href="/collections/all?sort_by=best-selling">Shop Popular</a>
        </div>
        ${slideshow(slideItems)}
      </div></div>

      <section><div class="wrap">
        <div class="sec-head"><div class="kick">Browse The Vault</div><h2>Shop By Category</h2><div class="rule"></div></div>
        <div class="cats">
          <a class="cat" href="/collections/nintendo"><img src="${CATALOG.nintendo[0].img}"><div class="label">Nintendo</div></a>
          <a class="cat" href="/collections/ps4-ps5"><img src="${CATALOG.playstation[1].img}"><div class="label">PlayStation</div></a>
          <a class="cat" href="/collections/xbox-consoles-accessories"><img src="${CATALOG.xbox[0].img}"><div class="label">Xbox</div></a>
          <a class="cat" href="/collections/toys"><img src="${CATALOG.toys[1].img}"><div class="label">Toys</div></a>
          <a class="cat" href="/collections/health-hygiene"><img src="${((CATALOG.gloves&&CATALOG.gloves[0])||(CATALOG.misc&&CATALOG.misc[0])||{}).img}"><div class="label">Health &amp; Hygiene</div></a>
          <a class="cat" href="/collections/all?sort_by=best-selling"><img src="${(CATALOG.popular[6]||CATALOG.popular[0]).img}"><div class="label">Popular</div></a>
        </div>
      </div></section>

      <section style="padding-top:0"><div class="wrap">
        <div class="sec-head"><div class="kick">Most Wanted</div><h2>Popular Right Now</h2><div class="rule"></div></div>
        ${grid(_pool.slice(0,4),"popular")}
        <div style="text-align:center;margin-top:30px"><a class="gold-btn" href="/collections/all?sort_by=best-selling">See All Popular</a></div>
      </div></section>

      <section style="padding-top:0"><div class="wrap">
        <div class="sec-head"><div class="kick">In Stock Now</div><h2>Featured Products</h2><div class="rule"></div></div>
        ${featGrid}
      </div></section>`;
    initSlideshow();
    trustMount();
  }

  let _catItems=[], _catKey="", _catShown=0;
  const PAGE_SIZE=8;
  function renderMore(){
    const g=document.getElementById("catGrid"); if(!g) return;
    const next=_catItems.slice(_catShown,_catShown+PAGE_SIZE);
    g.insertAdjacentHTML("beforeend", next.map(p=>card(p,_catKey)).join(""));
    _catShown+=next.length;
    const b=document.getElementById("showMore");
    if(b) b.style.display = _catShown<_catItems.length ? "inline-block" : "none";
  }
  async function category(key,title,sub,note){
    chrome(key); await load();
    _catItems=CATALOG[key]||[]; _catKey=key; _catShown=0;
    const inStock=_catItems.filter(p=>!p.sold).length;
    const kick = inStock>0 ? inStock+" In Stock" : "Restocking Soon";
    const banner = note ? `<div class="coming"><span class="gold-text">★</span> ${note}</div>` : "";
    document.getElementById("main").innerHTML=`
      <div class="cat-banner"><div class="wrap">
        <div class="crumb"><a href="/">Home</a> &nbsp;/&nbsp; ${title}</div>
        <h1>${title}</h1><p>${sub}</p><div class="rule"></div>
      </div></div>
      <section><div class="wrap">
        ${banner}
        <div class="sec-head"><div class="kick">${kick}</div><h2>Shop ${title}</h2><div class="rule"></div></div>
        ${_catItems.length
          ? '<div class="grid" id="catGrid"></div><div class="more-wrap"><button class="gold-btn" id="showMore">Show More</button></div>'
          : '<p style="text-align:center;color:#888">New stock arriving soon — call '+PHONE+'.</p>'}
      </div></section>`;
    if(_catItems.length){ renderMore(); const b=document.getElementById("showMore"); if(b) b.onclick=renderMore; }
    trustMount();
  }

  function basic(active){ chrome(active); trustMount(); }

  /* ---------- request / notify forms ---------- */
  function form(kind,item){
    chrome(kind==='looking'?'looking':'');
    const isNotify = kind==='notify';
    const title = isNotify ? "Get Restock Alerts" : "Looking for Something Else?";
    const crumb = isNotify ? "Notify Me" : "Looking for Something?";
    const intro = isNotify
      ? `Want <strong>${item||'this item'}</strong> the moment it’s back in stock? Leave your details and pick how you’d like to hear from us — we’ll reach out the second it lands.`
      : `We’re always open to finding new products. Let us know what you’re looking for and we’ll let you know if we can help. Leave your contact info and we’ll reach out the moment we track it down.`;
    document.getElementById("main").innerHTML=`
      <div class="cat-banner"><div class="wrap">
        <div class="crumb"><a href="/">Home</a> &nbsp;/&nbsp; ${crumb}</div>
        <h1>${title}</h1><div class="rule"></div>
      </div></div>
      <div class="page"><div class="wrap" style="max-width:680px">
        <p style="text-align:center;margin:0 auto 30px">${intro}</p>
        <div class="req-card" id="reqCard">
          ${isNotify
            ? `<label class="flbl">Item you want</label><input class="field" id="f_item" value="${(item||'').replace(/"/g,'&quot;')}" readonly>`
            : `<label class="flbl">What are you looking for?</label><input class="field" id="f_item" placeholder="e.g. PS5 Pro, a specific amiibo, Pokémon cards…">`}
          <label class="flbl">Email address</label><input class="field" id="f_email" type="email" placeholder="you@email.com">
          <label class="flbl">Phone number</label><input class="field" id="f_phone" type="tel" placeholder="(   )   -">
          <div class="pref"><span class="flbl">Preferred contact method</span>
            <div class="radio-row">
              <label class="radio"><input type="radio" name="pref" value="Email" checked> Email</label>
              <label class="radio"><input type="radio" name="pref" value="Phone call"> Phone call</label>
              <label class="radio"><input type="radio" name="pref" value="Text"> Text</label>
            </div>
          </div>
          <button class="gold-btn" id="reqSubmit" style="width:100%">${isNotify?'Notify Me When It’s Back':'Send My Request'}</button>
        </div>
      </div></div>`;
    trustMount();
    document.getElementById("reqSubmit").onclick=()=>{
      const pref=(document.querySelector('input[name=pref]:checked')||{}).value||"Email";
      document.getElementById("reqCard").innerHTML=`<div class="req-done">
        <div class="rd-check">✓</div>
        <h3>You're all set!</h3>
        <p>We’ll reach out by <strong>${pref}</strong> ${isNotify?"the moment this item is back in stock":"if we can track this down for you"}. Thanks for shopping AceBeach — no gambles, just guarantees.</p>
        <a class="gold-btn" href="/">Back to Home</a>
      </div>`;
    };
  }

  return {home,category,basic,form,toast,mount,homeBody:home};
})();
window.ACE = ACE;
